export default __webpack_public_path__ + "static/media/Group 626063.d6284187.svg";